var exports = {
  "f0": "xcc377c0b--d4b471--labels-layout",
  "Pf": "xcc377c0b--d4b471--label",
  "YL": "xcc377c0b--d4b471--tooltip",
};

module.exports = exports;
